import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function reauthenticateCourtiersRequest(isLoading) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_COURTIERS_REQUEST,
    isLoading,
  }
}
function reauthenticateCourtiersFailure(isError) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_COURTIERS_FAILURE,
    isError,
  }
}
function reauthenticateCourtiersSuccess(isSuccess, courtierData) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_COURTIERS_SUCCESS,
    isSuccess,
    courtierData
  }
}
export function fetchReauthenticateCourtiersAction() {
  return function(dispatch, getState) {

    dispatch(reauthenticateCourtiersRequest(true))

    return backendMembers.reauthenticateCourtier(localStorage.getItem("feathers-jwt"), "courtiers")
      .then(courtierData => {
        
        let souscripteurID = localStorage.getItem("souscripteurID")
        if(souscripteurID) {
          courtierData["souscripteurID"] = souscripteurID
        }

        dispatch(reauthenticateCourtiersRequest(false))
        dispatch(reauthenticateCourtiersSuccess(true, courtierData))
      })
      .catch(error => {
        dispatch(reauthenticateCourtiersRequest(false))
        dispatch(reauthenticateCourtiersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/ReauthenticateCourtiers.js